export const environment = {
  production: false,
  //apiUrl: 'https://localhost:7142/api',
  apiUrl: 'https://aradadeli.com/api',
};
